import { apiCall } from "./Interceptor";

const CONTACT_US = "/contact-us/public";

const sendEmail = async (data) => {
    const response = await apiCall.post(CONTACT_US,data);
    return response;
}

export default {
    sendEmail,
};
